var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nof"},[_c('h1',[_vm._v("你要的页面未找到....")]),_c('h2',[_vm._v("404 NotFound.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])}]

export { render, staticRenderFns }